import React, { PureComponent } from 'react';
import { Slider as ReactSlider } from '@mui/material';

export type SliderProps = {
  low: number;
  high: number;
  min: number;
  max: number;
  onChange: (low: number, high: number, event?: MouseEvent | undefined) => void;
};

type SliderState = {
  value: number[];
  event: MouseEvent | undefined;
};

export default class Slider extends PureComponent<SliderProps, SliderState> {
  constructor(props) {
    super(props);

    const { low, high, min, max } = this.props;

    this.state = {
      value: [low || min, high || max],
      event: undefined
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.low !== prevProps.low ||
      this.props.high !== prevProps.high
    ) {
      this.setState({ value: [this.props.low, this.props.high] });
    }
  }

  onChange = (event, value) => {
    this.setState({ value, event });
  };

  handleCommitChange = () => {
    this.props.onChange(
      this.state.value[0],
      this.state.value[1],
      this.state.event
    );
  };

  render() {
    const { min, max } = this.props;
    const { value } = this.state;

    return (
      <div style={{ display: 'flex' }}>
        <span>{min}</span>
        <ReactSlider
          className="awc-slider"
          title="awc-slider"
          valueLabelDisplay="on"
          value={value}
          min={min}
          max={max}
          onChange={this.onChange}
          onChangeCommitted={this.handleCommitChange}
        />
        <span>{max}</span>
      </div>
    );
  }
}
